import useCache from "../../hooks/use-cache";
import useLocalization from "../../hooks/use-localization";
import { useGetNewsQuery } from '../../store';
import PostMicro from "../news/posts/PostMicro";

export default function LastNews() {
    const localization = useLocalization();

    const cacheKey1 = `news-all-0`;
    const posts = useCache(cacheKey1, useGetNewsQuery, { id: 'all', pageIdentifier: 0 });

    if (!posts?.data?.length) { return; }

    const renderedPosts = posts.data.slice(0, 3).map((p) => {
        return <PostMicro key={p.id} post={p}></PostMicro>
    });

    return (
        <div className="footer-item">
            <span className="title-h2 title-underscore">{localization.lastNews}</span>
            <div className="footer-text">
                {renderedPosts}
            </div>
        </div>
    )
}